var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { baseCommon, configCommon, merchantCommon, } from '@repo/api/endpoints/merchant/msw/mocks/common';
export var LOAN_APPLICATION_LOWER_PRIVILEGE_LEVEL = __assign(__assign({}, baseCommon), { type: 'IFRAME_MERCHANT_SUMMARY', currentProvider: ['test-provider'], data: {
        merchantData: __assign(__assign({}, merchantCommon), { user: {
                type: 'limit',
                userId: 12345,
                permission: {
                    widget: true,
                    newLoan: false,
                    cancelLoan: true,
                    continueLoan: true,
                },
                accessFor: ['193421', '1234', '4321'],
            } }),
        preLimits: [
            {
                id: 1732011441,
                min: 3000,
                max: 35920,
                currency: 'PLN',
                provider: 'test-provider',
                availableLimitRevenueRate: [
                    {
                        period: 12,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                    {
                        period: 6,
                        pricing: 30,
                        loanRepaymentPrice: 3.6,
                        amountMin: 10000,
                        amountMax: 20000,
                    },
                ],
            },
        ],
        limits: [],
        loans: [],
        agreements: null,
        transfers: [],
        offers: [],
    }, config: configCommon });
